import {
  IconButton, Flex, P, useCombinedUser,
  useAsyncFunctionProgress,
} from '@equifinance/shared';
import moment from 'moment';
import styled from 'styled-components';
import { useEffect } from 'react';
import Page from '../components/Page';
import CasesTable from '../components/CasesTable/CasesTable';
import { useCasesUIContext } from '../contexts/casesUI/CasesUIProvider';

const SubHeadContainer = styled(Flex)`${({ theme }) => `
  justify-content: space-between;
  gap: ${theme.padding[2]};
  align-items: center;
  height: ${theme.collapseHeaderHeight};
  padding: 0 ${theme.padding[8]};
  background: ${theme.colours.neutral[9]};
  box-shadow: ${theme.boxShadow[2]};
`}`;

const RefreshContainer = styled(Flex)`${({ theme }) => `
  align-items: center;
  gap: ${theme.padding[4]};
`}`;

const RefreshInfo = styled(P)`${({ theme }) => `
  color: ${theme.colours.neutral[3]};
`}`;

const RefreshBtn = styled(IconButton)`${({ theme }) => `
  color: ${theme.colours.link[1]};
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.bolder};
`}`;

const BrokerageName = styled.p`${({ theme }) => `
  font-family: 'Montserrat';
  color: ${theme.colours.neutral[4]};
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.bold};
`}`;

function Home() {
  const { refreshData, lastRetrieved, setLastRetrieved } = useCasesUIContext();
  const { user } = useCombinedUser();

  const handleRefresh = async () => {
    await refreshData();
  };

  const { inProgress, execute: executeRefresh } = useAsyncFunctionProgress(handleRefresh);

  useEffect(() => {
    setLastRetrieved(new Date());
  }, []);

  return (
    <Page subHeader={(
      <SubHeadContainer>
        <BrokerageName>
          {`Brokerage: ${user?.companyTradingName}`}
        </BrokerageName>
        <RefreshContainer>
          <RefreshInfo>
            {`Last retrieved: ${moment(lastRetrieved).format('DD/MM/YYYY, HH:mm')}`}
          </RefreshInfo>
          <RefreshBtn disabled={inProgress} onClick={executeRefresh}>
            <i className="mi-refresh" />
            Refresh
          </RefreshBtn>
        </RefreshContainer>
      </SubHeadContainer>
    )}
    >
      <CasesTable />
    </Page>
  );
}

export default Home;
